import { useCallback, useState } from 'react';

type UseEditionModeReturnType = {
  isEditionMode: boolean;
  startEditionMode: () => void;
  finishEditionMode: () => void;
};

const useEditionMode = (
  setGlobalEditionMode?: (isEditionMode: boolean) => void,
): UseEditionModeReturnType => {
  const [isEditionMode, setIsEditionMode] = useState(false);

  const handleEditionModeChange = useCallback(
    (isEditionMode: boolean): void => {
      setIsEditionMode(isEditionMode);
      setGlobalEditionMode && setGlobalEditionMode(isEditionMode);
    },
    [setGlobalEditionMode],
  );

  const startEditionMode = useCallback(
    (): void => {
      handleEditionModeChange(true);
    },
    [handleEditionModeChange],
  );

  const finishEditionMode = useCallback(
    (): void => {
      handleEditionModeChange(false);
    },
    [handleEditionModeChange],
  );

  return {
    isEditionMode,
    startEditionMode,
    finishEditionMode,
  };
};

export type { UseEditionModeReturnType };
export { useEditionMode };
